export default __webpack_public_path__ + "static/media/ArrowDown.fce9bdd0.svg";